import React, { useState } from "react";
import { isEmpty } from "helper/Functions";
import { cn } from "helper/Utils";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const GamesFiltersBar = ({
  searchProviders,
  setSearchProviders,
  searchGames,
  handleGameSearch,
  sortOrder,
  setSortOrder,
  isProvidersVisible,
  setIsProvidersVisible,
  selectedProviders,
  toggleProviderSelection,
  setIsProvidersModal,
}) => {
  const { t } = useTranslation();

  const [isSearchVisible, setIsSearchVisible] = useState(false);

  return (
    <div className="flex justify-between gap-2 p-2">
      <div className="flex items-center gap-2 w-full">
        <div
          className={cn(
            "transition-transform duration-300 ease-in-out",
            isProvidersVisible ? "translate-x-0 sm:block hidden" : "-translate-x-full hidden -ml-3"
          )}
        >
          <input
            value={searchProviders}
            onChange={(e) => setSearchProviders(e.target.value)}
            type="text"
            className="relative bg-[rgb(38,48,69,1)] text-md text-white pl-3 h-10 rounded focus-within:border-none focus-within:outline-none"
            placeholder={t("Provider Search")}
          />
          <div className="searchInputIcon">
            <i className="bc-i-search absolute bottom-1 right-3 text-white top-3"></i>
          </div>
        </div>

        <div className={cn("hidden sm:flex gap-2 flex-auto")}>
          <button
            className="bg-[rgb(38,48,69,1)] h-10 w-10 rounded flex items-center justify-center cursor-pointer"
            onClick={() => setIsProvidersVisible(!isProvidersVisible)}
          >
            {isProvidersVisible ? <i className="bc-i-menu-open text-white text-[20px]" /> : <i className="bc-i-menu-close text-white text-[20px]" />}
          </button>
          <button
            className={cn(
              "bg-[rgb(38,48,69,1)] h-10 w-10 rounded flex items-center justify-center cursor-pointer",
              sortOrder ? "bg-white text-black" : "text-white"
            )}
            onClick={() => setSortOrder(!sortOrder)}
          >
            <i className="bc-i-show-all-categories text-[20px]"></i>
          </button>
          {/* <div className="flex gap-2">
            {isEmpty(selectedProviders) &&
              selectedProviders?.map((provider) => (
                <span className="flex items-center rounded px-3 gap-2 text-white border border-white/15 text-sm">
                  {provider.label} <i className="cursor-pointer bc-i-close-remove text-[10px]" onClick={() => toggleProviderSelection(provider)} />
                </span>
              ))}
          </div> */}
        </div>

        {/* MOBILE BUTTON */}
        <div className="sm:hidden flex gap-2 items-center">
          <button
            className={cn("h-10 w-10 rounded flex items-center justify-center cursor-pointer", sortOrder ? "bg-white text-black" : "text-white")}
            onClick={() => setSortOrder(!sortOrder)}
          >
            <i className="bc-i-show-all-categories text-[18px]"></i>
          </button>
          <div className="flex items-center gap-2">
            <button
              className="h-[45px] rounded flex gap-2 text-white items-center justify-center cursor-pointer"
              onClick={() => {
                setIsProvidersModal(true);
              }}
            >
              <i className={cn("bc-i-filter text-[16px] text-white/60", !isEmpty(selectedProviders) ? "text-primary" : "text-white")} />{" "}
              {isEmpty(selectedProviders) ? (
                "Select Providers"
              ) : (
                <>
                  {t("Providers")} ({selectedProviders}){" "}
                </>
              )}{" "}
            </button>
            {!isEmpty(selectedProviders) && (
              <i className="bc-i-clear text-white/60 hover:text-white/100 cursor-pointer" onClick={() => toggleProviderSelection(null, "clear")} />
            )}
          </div>
        </div>
        {/* MOBILE BUTTON */}
        <div
          className={cn(
            "overflow-x-hidden sm:relative absolute ml-auto sm:min-w-[250px] right-2",
            isSearchVisible ? "w-[calc(100%-1.25rem)]" : "w-8"
          )}
        >
          <input
            value={searchGames}
            onChange={(e) => handleGameSearch(e.target.value)}
            type="text"
            className={cn(
              "sm:relative w-full transition-all duration-300 ease-in-out bg-[rgb(38,48,69,1)] text-md text-white pl-3 sm:h-10 h-[45px] rounded border-none outline-none",
              isSearchVisible ? "translate-x-0 w-full opacity-1" : "sm:translate-x-0 translate-x-full sm:opacity-100 opacity-0"
            )}
            placeholder={t("Game Search")}
          />
          <div className="hidden sm:flex absolute bottom-1 right-3 top-3">
            <i className="bc-i-search text-white" />
          </div>
          <div
            className="sm:hidden block absolute bottom-1 right-3 text-white top-[14px]"
            onClick={() => {
              setIsSearchVisible(!isSearchVisible);
              isSearchVisible && handleGameSearch("");
            }}
          >
            <i className="bc-i-search"></i>
          </div>
        </div>
      </div>
    </div>
  );
};
